import { render, staticRenderFns } from "./PhysicianDuty.vue?vue&type=template&id=3b8f50c6&"
import script from "./PhysicianDuty.vue?vue&type=script&lang=js&"
export * from "./PhysicianDuty.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianDuty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports